export default __webpack_public_path__ + "static/media/developer.29c95b74.svg";